'use strict';

DoohApps
    .factory('ScheduleHelper', ['$filter', 'DoohHelper',
        function ($filter, DoohHelper) {

            var schedulePriority = {
                low: { name: 'Low', value: 1 },
                normal: { name: 'Normal', value: 2 },
                high: { name: 'High', value: 3 }
            }

            var flags = {};
            resetFlags();
                        
            var calendar = {};
            resetCalendarObject();
            //should not be reset, is updated on calendar view change
            calendar.viewEndDate = null;

            var eventInfo = {
                campaignSchedule : null
            };
            resetEventInfo();

            var TIME_UNITS = {
                seconds: 'seconds',
                minutes: 'minutes',
                hours: 'hours',
                days: 'days'
            }

            var userSelectedData = {
                chosenDevices: [],
                chosenCampaign: null,
                selectedEvent: null
            }

            const ZERO_TIME = '00:00'

            var schedule = {
                events: []
            }

     return {
        getScheduleConflictList: function (startDateFull, endDateFull, eventList, deviceList, isBackground) {
            for (var devIndex = 0; devIndex < deviceList.length; devIndex++) {
                var devEventList = [];

                devEventList = getDeviceEvents(deviceList[devIndex], eventList, this.groupsWithDeviceIDs);

                deviceList[devIndex].conflictList = [];

                var eventsInTimeFrame = getEventsInTimeFrame(startDateFull, endDateFull, devEventList, isBackground);
                if (eventsInTimeFrame.length > 0) {
                    angular.forEach(this.getSchedulePriority(), function (priority) {
                        groupEventsByPriority(priority, eventsInTimeFrame, deviceList, devIndex);
                    });
                }
            }

            return deviceList;
        },
        getOverlapInTimeFrame: function (eventList, startDateFull, endDateFull, mediaID, groupID, isBackground) {
            eventList = getDeviceEvents({ MediaID: mediaID, GroupID: groupID }, eventList, this.groupsWithDeviceIDs)

            var eventsInTimeFrame = getEventsInTimeFrame(startDateFull, endDateFull, eventList, isBackground);

            return eventsInTimeFrame;
        },
        getEventsInTimeFrame: getEventsInTimeFrame,
        getScheduleConflictListRepeats: function (repeats, eventList, deviceList, isBackground) {
            for (var devIndex = 0; devIndex < deviceList.length; devIndex++) {
                var devEventList = getDeviceEvents(deviceList[devIndex], eventList, this.groupsWithDeviceIDs);

                deviceList[devIndex].conflictList = [];

                for (var r = 0; r < repeats.length ; r++) {
                    var eventsInTimeFrame = getEventsInTimeFrame(repeats[r].TimeStart, repeats[r].TimeEnd, devEventList, isBackground, repeats[r].ParentId);
                    if (eventsInTimeFrame.length > 0) {
                        angular.forEach(this.getSchedulePriority(), function (priority) {
                            groupEventsByPriority(priority, eventsInTimeFrame, deviceList, devIndex);
                        });
                    }
                }
            }

            return deviceList;
        },
        getLoopPeriodsWithEvents: function (eventList) {
            var periods = [];

            angular.forEach(eventList, function (eventTypeGroup, indx) {
                angular.forEach(getAllPeriods(eventTypeGroup.Events), function (period, indx) {
                    periods.push({
                        start: period.start,
                        end: period.end,
                        conflictType: eventTypeGroup.ConflictType,
                        events: getEventsInTimeFrame(period.start, period.end, eventTypeGroup.Events)
                    });
                });
            });

            return periods;
        },
        getTransferState: function (value) {
            switch (value + '') {
                case '0':
                    return this.transferAwait;
                case '1':
                    return this.transferingWaitConn;
                case '2':
                    return this.transfering;
                case '3':
                    return this.transferingError;
                case '4':
                    return this.transferCompleted;
                default:
                    return this.transferUnknow;
            }
        },
        transferAwait: angular.copy({ state: 'Awaiting transfer', value: 0 }),
        transferingWaitConn: angular.copy({ state: 'Transfering (awaiting connection)', value: 1 }),
        transfering: angular.copy({ state: 'Transfering', value: 2 }),
        transferingError: angular.copy({ state: 'Transfering (errors occured)', value: 3 }),
        transferCompleted: angular.copy({ state: 'Completed', value: 4 }),
        transferUnknow: angular.copy({ state: 'unknown', value: -1 }),
        getSchedulePriority: function () { return angular.copy(schedulePriority) },
        getPriorityOptionByValue: function (value) {
            switch (value) {
                case 1:
                    return angular.copy(schedulePriority.low);
                case 2:
                    return angular.copy(schedulePriority.normal);
                case 3:
                    return angular.copy(schedulePriority.high);
            }
        },
        groupsWithDeviceIDs: [],
        selectedEventTransfer: null,
        flags: flags,
        normalizeRepeatDate: normalizeRepeatDate,
        calendar: calendar,
        eventInfo: eventInfo,
        TIME_UNITS: TIME_UNITS,
        userSelectedData: userSelectedData,
        ZERO_TIME: ZERO_TIME,
        schedule: schedule,
        resetEventInfo: resetEventInfo,
        resetCalendarObject: resetCalendarObject,
        resetFlags: resetFlags,
    }

    function groupEventsByPriority(priority, eventsInTimeFrame, deviceList,devIndex) {
        var priorityEventsInList = getEventsInListByPriority(priority, eventsInTimeFrame);
        var priorityConfIndex = DoohHelper.findWithAttr(deviceList[devIndex].conflictList, 'ConflictType', priority.value);
        if (priorityConfIndex == -1) {
            deviceList[devIndex].conflictList.push({
                ConflictType: priority.value,
                Events: []
            });
            priorityConfIndex = DoohHelper.findWithAttr(deviceList[devIndex].conflictList, 'ConflictType', priority.value);
        }
        if (priorityEventsInList.length > 0) {
            var concatEvents = deviceList[devIndex].conflictList[priorityConfIndex].Events.concat(priorityEventsInList);
            deviceList[devIndex].conflictList[priorityConfIndex].Events = concatEvents;
        }
    }

    function getDeviceEvents(device, eventList, groupsWithDeviceIDs) {
        var devEventList = [];
        if (device.MediaID != null && device.MediaID != 0) {

            devEventList = eventList.filter(scheduleEvent => scheduleEvent.MediaID == device.MediaID);

            //also get group events
            var deviceGroupIDs = getGroupIDsByDeviceID(groupsWithDeviceIDs, device.MediaID);
            devEventList = getGroupOverlappingEvents(deviceGroupIDs, devEventList, eventList);

        } else if (device.GroupID != null && device.GroupID != 0) {
            //also get device of group events
            devEventList = eventList.filter(scheduleEvent => scheduleEvent.GroupID == device.GroupID);
            var tmpDeviceIDs = groupsWithDeviceIDs.filter(grp => grp.GroupID == device.GroupID).map(m => m.MediaIDs);
            var groupDeviceIDs = removeDuplicates(flattenArrays(tmpDeviceIDs));
            devEventList = getDeviceOverlappingEvents(groupDeviceIDs, devEventList, eventList);

            //also get events where one device is part of two groups
            var tmpGroupIDs = groupDeviceIDs.map(groupDeviceID => groupsWithDeviceIDs.filter(grp => grp.MediaIDs.indexOf(groupDeviceID != -1)).map(m => m.GroupID));
            let deviceGroupsIDs = removeDuplicates(flattenArrays(tmpGroupIDs));
            devEventList = getGroupOverlappingEvents(deviceGroupsIDs, devEventList, eventList);
        }
        return $filter('orderBy')(devEventList, 'start');
    }

    function getGroupIDsByDeviceID(groupsWithDeviceIDs, deviceID) {
        return removeDuplicates(groupsWithDeviceIDs.filter(grp => grp.MediaIDs.indexOf(deviceID) != -1)
            .map(m => m.GroupID));
    }

    function removeDuplicates(list) {
        return list.filter(function (elem, index, self) {
            return index == self.indexOf(elem);
        });
    }

    function flattenArrays(array) {
        return [].concat.apply([], array);
    }

    function getGroupOverlappingEvents(groupIDs, devEventList, eventList) {
        for (var groupIndex = 0; groupIndex < groupIDs.length; groupIndex++) {
            let tmpDevEventList = eventList.filter(scheduleEvent => scheduleEvent.GroupID == groupIDs[groupIndex]);
            devEventList = devEventList.concat(tmpDevEventList);
        }
        return devEventList;
    }

    function getDeviceOverlappingEvents(groupDeviceIDs, devEventList, eventList) {
        for (var dIndex = 0; dIndex < groupDeviceIDs.length; dIndex++) {
            let tmpDevEventList = eventList.filter(scheduleEvent => scheduleEvent.MediaID == groupDeviceIDs[dIndex]);
            devEventList = devEventList.concat(tmpDevEventList);
        }
        return devEventList;
    }

    function getAllPeriods(events) {
        var allDates = [];

        angular.forEach(events, function (event) {
            if (allDates.indexOf(event.start) == -1) {
                allDates.push(event.start);
            }
            if (allDates.indexOf(event.end) == -1) {
                allDates.push(event.end);
            }
        });

        allDates.sort();

        var periods = [];
        for (var x = 0; x < allDates.length; x++) {
            if (allDates[x + 1] != null) {
                periods.push({
                    start: allDates[x],
                    end: allDates[x + 1]
                });
            }
        }

        return periods;
    }
        
    function getEventsInTimeFrame(start, end, eventList, isBackground, parent) {
        var list = [];
        angular.forEach(eventList, function (e) {
            var compareStart, compareEnd;
            compareStart = e.start;
            compareEnd = e.end;

            if (DoohHelper.stringToDateObject(compareStart) < DoohHelper.stringToDateObject(end) &&
                DoohHelper.stringToDateObject(compareEnd) > DoohHelper.stringToDateObject(start) &&
                (isBackground == null || isBackground == false || e.IsBackground == true)) {
                if (!parent) list.push(e);
                else if (!(e.ParentId != null && e.ParentId == parent)) list.push(e);
            }
        });
        return list;
    }

    function getEventsInListByPriority(priority, eventList) {
        var filteredEventList = [];

        for (var i = 0; i < eventList.length; i++) {
            if (eventList[i].PriorityCode == priority.value)
                filteredEventList.push(eventList[i]);
        }
        return filteredEventList;
    }

    function normalizeRepeatDate(originalDate, timeToSet, isAllDay, shouldReturnNextDay) {
        var returnDate;
        var tzName = moment.tz.guess();
        if (typeof originalDate == 'string') {
            returnDate = originalDate;
            if (returnDate.replace('T', ' ').split(' ').length > 1) return returnDate;
        } else
            returnDate = moment(originalDate).tz(tzName).format(DoohHelper.dcFormat);

        if (isAllDay) {
            returnDate = shouldReturnNextDay
                ? `${DoohHelper.stringToMomentNoTime(returnDate).add(1, TIME_UNITS.days).format(DoohHelper.dcFormat)} ${ZERO_TIME}`
                : `${returnDate} ${ZERO_TIME}`;
        } else
            returnDate = `${returnDate} ${timeToSet}`;

        return returnDate;
    }

    function resetEventInfo() {
        eventInfo.playtime = 0;
        eventInfo.repeatPlaceHolders = [];
        eventInfo.showTime = {};
        eventInfo.hasStartDateChanged = false;
        eventInfo.hasEventStartTimeChanged = false;
        eventInfo.isExistingEvent = false;
        eventInfo.transferState = {};
        eventInfo.overlapCount = 0;
    }

    function resetCalendarObject() {
        calendar.startDate = null;
        calendar.endDate = null;
        calendar.isRepeatAllowed = false;
        calendar.combinedEvents = [];
        calendar.missingEvents = null;
        calendar.isRepeatStartChangeAllowed = false;
    }

    function resetFlags() {
        flags.isLicenseLoading = false;
        flags.isLoading = false;
        flags.canAddLicense = false;
        flags.canAquireLicense = false;
        flags.isSchedulingAllowed = true;
        flags.isEventInPast = false;
        flags.isOverlapLoading = false;
    }
}]);